import {BaseMetric} from '../base/metric'
import {getSelector} from '../get-selector'

export interface INPAttribution {
  interactionTarget?: string
}

/*
 * The INP metric. This class is compatible with web-vitals' INPMetric interface that we expect to report to DataDog and Hydro.
 */
export class INPMetric extends BaseMetric<INPAttribution, PerformanceEventTiming> {
  name = 'INP' as const

  get attribution(): INPAttribution {
    const firstEntryWithTarget = this.entries.find(entry => entry.target)
    return {
      interactionTarget: getSelector(firstEntryWithTarget?.target),
    }
  }
}
